import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BookCopy, Plane, ArrowRight } from 'lucide-react';

const Reports = () => {
  const navigate = useNavigate();

  const reports = [
    {
      title: "كشف الجوازات",
      path: "/passport-report",
      icon: <BookCopy className="w-10 h-10 text-white" />,
      description: "عرض وإدارة تقارير الجوازات بشكل تفصيلي",
      color: "bg-cyan-500",
    },
    {
      title: "كشف الطيران",
      path: "/flight-report",
      icon: <Plane className="w-10 h-10 text-white" />,
      description: "عرض تقرير حجوزات وتذاكر الطيران",
      color: "bg-orange-500",
    },
  ];

  return (
    <div className="min-h-screen bg-gray-100 py-10">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Header */}
        <div className="bg-white rounded-lg shadow-md p-6 mb-10 flex justify-between items-center">
          <h1 className="text-3xl font-bold text-gray-900">الكشوفات</h1>
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-2 bg-gray-100 hover:bg-gray-200 text-gray-700 px-4 py-2 rounded-lg transition-colors"
          >
            <ArrowRight className="w-5 h-5" />
            العودة للرئيسية
          </button>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {reports.map((report, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300"
            >
              {/* Card Header */}
              <div className={`${report.color} p-8 flex flex-col items-center justify-center`}>
                <div className="bg-white/20 w-20 h-20 rounded-full flex items-center justify-center mb-3">
                  {report.icon}
                </div>
                <h3 className="text-2xl font-bold text-white">{report.title}</h3>
              </div>

              {/* Card Body */}
              <div className="p-6 text-center">
                <p className="text-gray-500 mb-6 text-sm leading-relaxed">
                  {report.description}
                </p>
                <button
                  onClick={() => navigate(report.path)}
                  className={`w-full py-3 rounded-xl font-semibold text-white transition-colors ${report.color} hover:opacity-90`}
                >
                  عرض الكشف
                </button>
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default Reports;